/** A tag's label past this many characters is cut with an ellipsis and shown whole in a tooltip. */
export const MAX_CHIP_LABEL_LENGTH = 24;
